import React, {FC} from 'react';
import {IWithDisabled} from 'models';
import {LanguagesSelect} from './LanguagesSelect';

type ILanguagesMultiSelectProps = IWithDisabled;

export const LanguagesMultiSelect: FC<ILanguagesMultiSelectProps> = ({disabled}) => {
  return <LanguagesSelect selectionType="multi" disabled={disabled} />;
};
